export const TextLabelTypes = {
  DEFAULT: 0,
  GREY_BOLD: 1,
  DARK_BOLD: 2,
  LARGE_DARK: 3,
  SMALL_LIGHT_GREY: 4,
  SMALL_WHITE: 5,
};
